const Image = ({ src, alt = '' }: { src: string; alt?: string }) => {
  return <img src={src || '/images/thumb.jpg'} alt={alt} />;
};

export default Image;
